import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Stack,
  IconButton,
  useTheme,
  CircularProgress
} from "@mui/material";
import {
  Close as CloseIcon,
  Business as BusinessIcon,
  Email as EmailIcon,
  Phone as PhoneIcon
} from "@mui/icons-material";

const EditAdminDetailsDialog = ({
  open,
  onClose,
  formData,
  setFormData,
  loading,
  handleSave,
}) => {
  const theme = useTheme();

  const handleEditChange = (e) => {
    const { name, value } = e.target;

    // Only allow numeric input in phone
    if (name === "phone") {
      const numericValue = value.replace(/\D/g, "");
      setFormData((prev) => ({
        ...prev,
        [name]: numericValue,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSaveClick = () => {
    const updatedData = {
      ...formData,
      phone: formData.phone.startsWith("+")
        ? formData.phone
        : `+${formData.phone}`,
    };
    handleSave(updatedData);
  };

  return (
    <Dialog
      open={open}
      onClose={() => !loading && onClose()}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        elevation: 3,
        sx: {
          borderRadius: 2,
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor: theme.palette.primary.main,
          color: "white",
          p: 2,
          mb: 1,
        }}
      >
        <Typography variant="h6" fontWeight="500">
          Edit Admin Details
        </Typography>
        <IconButton
          size="small"
          onClick={() => !loading && onClose()}
          sx={{ color: "white" }}
          disabled={loading}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        <Stack spacing={3} sx={{ mt: 1 }}>
          <TextField
            label="Company Name"
            name="name"
            value={formData.name}
            onChange={handleEditChange}
            fullWidth
            variant="outlined"
            disabled={loading}
            InputProps={{
              startAdornment: (
                <BusinessIcon sx={{ color: "text.secondary", mr: 1 }} />
              ),
            }}
          />
          <TextField
            label="Email"
            name="admin_email"
            value={formData.admin_email}
            onChange={handleEditChange}
            fullWidth
            variant="outlined"
            disabled={loading}
            InputProps={{
              startAdornment: (
                <EmailIcon sx={{ color: "text.secondary", mr: 1 }} />
              ),
            }}
          />
          <TextField
            label="Phone"
            name="phone"
            value={formData.phone}
            onChange={handleEditChange}
            fullWidth
            variant="outlined"
            disabled={loading}
            InputProps={{
              startAdornment: (
                <PhoneIcon sx={{ color: "text.secondary", mr: 1 }} />
              ),
            }}
          />
        </Stack>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          sx={{
            borderRadius: 2,
            textTransform: "none",
            mr: 1,
          }}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSaveClick}
          variant="contained"
          disabled={loading}
          sx={{
            borderRadius: 2,
            textTransform: "none",
            position: "relative",
          }}
        >
          {loading ? (
            <>
              Saving...
              <CircularProgress
                size={24}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            </>
          ) : (
            "Save Changes"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditAdminDetailsDialog;
